export enum IndicatorTrendStatuses {
  None = 0,
  Trending_Up = 1,
  Trending_Down = 2,
  Pass = 3,
  Fail = 4,
}
